import React from 'react'
import {
  Box,
  Button,
  Image,
  Tr,
  Td,
} from '@chakra-ui/react'
import { useCurrency } from 'app/hooks/Tokens'
import DoubleCurrencyLogo from 'app/components/DoubleLogo'
import { formatNumber, getApy } from 'app/functions'

interface PoolDetailItemProps {
  pair: {
    pair: {
      token0: {
        id: string
        symbol: string
      }
      token1: {
        id: string
        symbol: string
      }
      id: string
    }
    liquidity: number
    volume1d: number
    volume1w: number
  }
  onOpenPool(): void
}
export default function PoolDetailItem({ pair, onOpenPool }: PoolDetailItemProps) {
  const token0 = useCurrency(pair?.pair?.token0?.id)
  const token1 = useCurrency(pair?.pair?.token1?.id)

  return (
    <Tr className='click_btn_as' onClick={onOpenPool}>
      <Td>
        <Box className='for_line_tble for_line_tble_va'>
          <DoubleCurrencyLogo
            className="hdr_btn_had hdr_btn_hadv2"
            logoClassName="rounded-full"
            currency0={token0}
            currency1={token1}
            size={20}
          />
        </Box>
      </Td>
      <Td>
        {pair?.pair?.token0?.symbol}/{pair?.pair?.token1?.symbol}
      </Td>
      <Td>{formatNumber(pair?.liquidity, true, false, 2)}</Td>
      <Td>{formatNumber(pair?.volume1d, true, false, 2)}</Td>
      <Td>{formatNumber(pair?.volume1w, true, false, 2)}</Td>
      <Td>{getApy(pair?.volume1w, pair?.liquidity)}</Td>
    </Tr>
  )
}